module.exports = __webpack_public_path__ + "static/media/time.f28f8109.svg";